(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.isci = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
module.exports = function(opts) {
  const KEYWORD_REGEX = new RegExp('\\[([^\\[\\]]+)\\]');
  const PARAM_REGEX = new RegExp('<([^<>]+)>');
  const KEYWORD_HANDLERS = {
    ...opts.keywordHandlers
  };

  const processKeyword = keywordOpt => {
    return KEYWORD_HANDLERS[keywordOpt.type]
      ? KEYWORD_HANDLERS[keywordOpt.type](keywordOpt)
      : '';
  };

  /**
   * Get next ID from ISCI Schema
   * @returns {string}
   * @param {object} isci ISCI Schema
   * @param {string} isci.name ISCI Name
   * @param {string} isci.pattern ISCI Pattern
   * @param {object} isci.keywords ISCI Keywords
   * @param {object} params Your parameter to be passed
   */
  const next = (isci, params = {}) => {
    let result = isci.pattern;
    let matchedParam;
    let matchedKeyword;

    while ((matchedParam = PARAM_REGEX.exec(result)) !== null)
      result =
        result.substring(0, matchedParam.index) +
        (Object.prototype.hasOwnProperty.call(params, matchedParam[1])
          ? params[matchedParam[1]]
          : '') +
        result.substring(matchedParam.index + matchedParam[0].length);

    while ((matchedKeyword = KEYWORD_REGEX.exec(result)) !== null)
      result =
        result.substring(0, matchedKeyword.index) +
        (isci.keywords[matchedKeyword[1]]
          ? processKeyword(isci.keywords[matchedKeyword[1]])
          : '') +
        result.substring(matchedKeyword.index + matchedKeyword[0].length);

    return result;
  };

  return { next };
};

},{}],2:[function(require,module,exports){
const reverse = str => {
  let length = str.length;
  let reversed = '';
  while (length--) reversed += str[length];

  return reversed;
};

module.exports = {
  incrNumber: opts => {
    const result = opts.startNumber + opts.index + opts.increaser;

    opts.index += opts.increaser;

    return result;
  },
  incrCharset: opts => {
    const charsetLength = opts.charset.length;

    let currentIndex = opts.index;
    let length = opts.length;
    let result = '';

    while (length--) {
      const indexCharset = currentIndex % charsetLength;

      result += opts.charset[indexCharset];

      currentIndex = (currentIndex - indexCharset) / charsetLength;
    }

    result = reverse(result);
    opts.index += opts.increaser;

    return result;
  },
  incrCharsets: opts => {
    let result = '';
    let index = opts.index;

    let i = opts.charsets.length;
    while (i--) {
      const subCharset = opts.charsets[i];
      const subCharsetLength = subCharset.length;

      const indexCharset = index % subCharsetLength;

      result += subCharset[indexCharset];

      index = (index - indexCharset) / subCharsetLength;
    }

    result = reverse(result);
    opts.index += opts.increaser;

    return result;
  }
};

},{}],3:[function(require,module,exports){
const randomString = (charset, length) => {
  let result = '';

  while (length--)
    result += charset.charAt(Math.floor(Math.random() * charset.length));

  return result;
};

module.exports = {
  randCharset: keywordOpt =>
    randomString(
      keywordOpt.charset,
      keywordOpt.length
        ? keywordOpt.length
        : Math.floor(
            Math.random() * (keywordOpt.maxLength - keywordOpt.minLength + 1)
          ) + keywordOpt.minLength
    )
};

},{}],4:[function(require,module,exports){
module.exports = function({ next }) {
  const deepClone = require('rfdc')({
    proto: true
  });

  /**
   * Get next ID from ISCI Schema without manipulate original ISCI Schema
   * @returns {object}
   * @param {object} isci ISCI Schema
   * @param {string} isci.pattern ISCI Pattern
   * @param {object} isci.keywords ISCI Keywords
   * @param {object} params Your parameter to be passed
   */
  const immutableNext = (isci, params) => {
    const clonedIsci = deepClone(isci);

    return {
      result: next(clonedIsci, params),
      updated: clonedIsci
    };
  };

  return { next: immutableNext };
};

},{"rfdc":7}],5:[function(require,module,exports){
module.exports = require('./libs/makeImmutable')(require('./light-mutable'));

},{"./libs/makeImmutable":4,"./light-mutable":6}],6:[function(require,module,exports){
module.exports = require('./libs/createMutable')({
  keywordHandlers: {
    ...require('./libs/keywords/incr'),
    ...require('./libs/keywords/rand')
  }
});

},{"./libs/createMutable":1,"./libs/keywords/incr":2,"./libs/keywords/rand":3}],7:[function(require,module,exports){
'use strict'
module.exports = rfdc

function rfdc (opts) {
  opts = opts || {}

  if (opts.circles) return rfdcCircles(opts)
  return opts.proto ? cloneProto : clone

  function cloneArray (a, fn) {
    var keys = Object.keys(a)
    var a2 = new Array(keys.length)
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i]
      var cur = a[k]
      if (typeof cur !== 'object' || cur === null) {
        a2[k] = cur
      } else if (cur instanceof Date) {
        a2[k] = new Date(cur)
      } else {
        a2[k] = fn(cur)
      }
    }
    return a2
  }

  function clone (o) {
    if (typeof o !== 'object' || o === null) return o
    if (o instanceof Date) return new Date(o)
    if (Array.isArray(o)) return cloneArray(o, clone)
    var o2 = {}
    for (var k in o) {
      if (Object.hasOwnProperty.call(o, k) === false) continue
      var cur = o[k]
      if (typeof cur !== 'object' || cur === null) {
        o2[k] = cur
      } else if (cur instanceof Date) {
        o2[k] = new Date(cur)
      } else {
        o2[k] = clone(cur)
      }
    }
    return o2
  }

  function cloneProto (o) {
    if (typeof o !== 'object' || o === null) return o
    if (o instanceof Date) return new Date(o)
    if (Array.isArray(o)) return cloneArray(o, cloneProto)
    var o2 = {}
    for (var k in o) {
      var cur = o[k]
      if (typeof cur !== 'object' || cur === null) {
        o2[k] = cur
      } else if (cur instanceof Date) {
        o2[k] = new Date(cur)
      } else {
        o2[k] = cloneProto(cur)
      }
    }
    return o2
  }
}

function rfdcCircles (opts) {
  var refs = []
  var refsNew = []

  return opts.proto ? cloneProto : clone

  function cloneArray (a, fn) {
    var keys = Object.keys(a)
    var a2 = new Array(keys.length)
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i]
      var cur = a[k]
      if (typeof cur !== 'object' || cur === null) {
        a2[k] = cur
      } else if (cur instanceof Date) {
        a2[k] = new Date(cur)
      } else {
        var index = refs.indexOf(cur)
        if (index !== -1) {
          a2[k] = refsNew[index]
        } else {
          a2[k] = fn(cur)
        }
      }
    }
    return a2
  }

  function clone (o) {
    if (typeof o !== 'object' || o === null) return o
    if (o instanceof Date) return new Date(o)
    if (Array.isArray(o)) return cloneArray(o, clone)
    var o2 = {}
    refs.push(o)
    refsNew.push(o2)
    for (var k in o) {
      if (Object.hasOwnProperty.call(o, k) === false) continue
      var cur = o[k]
      if (typeof cur !== 'object' || cur === null) {
        o2[k] = cur
      } else if (cur instanceof Date) {
        o2[k] = new Date(cur)
      } else {
        var i = refs.indexOf(cur)
        if (i !== -1) {
          o2[k] = refsNew[i]
        } else {
          o2[k] = clone(cur)
        }
      }
    }
    refs.pop()
    refsNew.pop()
    return o2
  }

  function cloneProto (o) {
    if (typeof o !== 'object' || o === null) return o
    if (o instanceof Date) return new Date(o)
    if (Array.isArray(o)) return cloneArray(o, cloneProto)
    var o2 = {}
    refs.push(o)
    refsNew.push(o2)
    for (var k in o) {
      var cur = o[k]
      if (typeof cur !== 'object' || cur === null) {
        o2[k] = cur
      } else if (cur instanceof Date) {
        o2[k] = new Date(cur)
      } else {
        var i = refs.indexOf(cur)
        if (i !== -1) {
          o2[k] = refsNew[i]
        } else {
          o2[k] = cloneProto(cur)
        }
      }
    }
    refs.pop()
    refsNew.pop()
    return o2
  }
}

},{}]},{},[5])(5)
});
